/**
 * Created by nijin on 29/12/16.
 */
import {Directive, ElementRef, Input} from '@angular/core';
import {Md5} from 'ts-md5/dist/md5';
@Directive({
  selector: '[gravatar]'
})
export class Gravatar {
  @Input('email') email: string;
  @Input('size') size: number = 16;
  @Input('fallback') fallback: string = 'mm';

  constructor(private elementRef: ElementRef) {}

  ngOnInit() {
    this.elementRef.nativeElement.src = `//www.gravatar.com/avatar/${Md5.hashStr(this.email)}?s=${this.size}&d=${this.fallback}`;
  }
}
/*
available fallback options
 404: do not load any image if none is associated with the email hash, instead return an HTTP 404 (File Not Found) response
 mm: (mystery-man) a simple, cartoon-style silhouetted outline of a person (does not vary by email hash)
 identicon: a geometric pattern based on an email hash
 monsterid: a generated 'monster' with different colors, faces, etc
 wavatar: generated faces with differing features and backgrounds
 retro: awesome generated, 8-bit arcade-style pixelated faces
 blank: a transparent PNG image (border added to HTML below for demonstration purposes)
 */



// WEBPACK FOOTER //
// ./src/app/shared/gravatar/gravatar.directive.ts